<div class="log__status log__status-{{ log.send_status }}">
  {{ log.send_status | titlecase }}
</div>
